export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torso-female-05fac19952db90fb9725af5ed864ef6f.svg";